import type { Joi } from '@ksyos/koi';
import { cloneDeep } from 'lodash';

export function replaceErrorPath(errors: Joi.ErrorReport[], oldPath: string, newPath: string): Joi.ErrorReport[] {
    const errorsToUpdate = cloneDeep(errors);

    return errorsToUpdate.map((errorToUpdate) => {
        errorToUpdate.path[errorToUpdate.path.indexOf(oldPath)] = newPath;

        return errorToUpdate;
    });
}
